(() => {
  if (window.SWTNativeCartPageLoaded) return;
  window.SWTNativeCartPageLoaded = true;

  const form = document.querySelector('[data-swt-cart-form]');
  if (!form) return;

  let navigateTimer = null;
  let isNavigating = false;

  const numberValue = (value, fallback) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const clampToRules = (input, nextValue) => {
    const min = numberValue(input.getAttribute('min'), 1);
    const maxAttr = input.getAttribute('max');
    const max = maxAttr === null || maxAttr === '' ? null : numberValue(maxAttr, null);
    const step = Math.max(numberValue(input.getAttribute('step'), 1), 1);

    let value = numberValue(nextValue, min);
    value = Math.max(value, min);

    if (max !== null) value = Math.min(value, max);

    const remainder = (value - min) % step;
    if (remainder !== 0) value = value - remainder;

    value = Math.max(value, min);
    if (max !== null) value = Math.min(value, max);

    return value;
  };

  const getLineNumber = (line) => {
    const lines = Array.from(document.querySelectorAll('[data-swt-cart-line]'));
    const index = lines.indexOf(line);
    return index >= 0 ? index + 1 : null;
  };

  const goToLineChange = (line, input, delay = 80) => {
    if (isNavigating || !line || !input) return;

    const lineNumber = getLineNumber(line);
    if (!lineNumber) return;

    const quantity = clampToRules(input, input.value);
    input.value = quantity;

    line.classList.add('is-updating');
    form.classList.add('is-updating');

    clearTimeout(navigateTimer);
    navigateTimer = window.setTimeout(() => {
      isNavigating = true;
      const url = new URL('/cart/change', window.location.origin);
      url.searchParams.set('line', String(lineNumber));
      url.searchParams.set('quantity', String(quantity));
      window.location.assign(url.toString());
    }, delay);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-swt-qty-adjust]');
    if (!button || !form.contains(button)) return;

    const line = button.closest('[data-swt-cart-line]');
    const input = line ? line.querySelector('[data-swt-quantity-input]') : null;
    if (!input) return;

    const direction = button.getAttribute('data-swt-qty-adjust');
    const step = Math.max(numberValue(input.getAttribute('step'), 1), 1);
    const current = numberValue(input.value, numberValue(input.getAttribute('min'), 1));
    const next = direction === 'plus' ? current + step : current - step;
    const oldValue = String(input.value);
    const nextValue = String(clampToRules(input, next));

    input.value = nextValue;

    if (nextValue !== oldValue) {
      goToLineChange(line, input);
    }
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-swt-quantity-input]');
    if (!input || !form.contains(input)) return;

    const line = input.closest('[data-swt-cart-line]');
    const nextValue = String(clampToRules(input, input.value));
    const originalValue = String(input.getAttribute('data-swt-original-value') || '');

    input.value = nextValue;

    if (nextValue !== originalValue) {
      goToLineChange(line, input, 120);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;

    const input = event.target.closest('[data-swt-quantity-input]');
    if (!input || !form.contains(input)) return;

    const line = input.closest('[data-swt-cart-line]');
    event.preventDefault();

    input.value = String(clampToRules(input, input.value));
    goToLineChange(line, input, 0);
  });

  form.addEventListener('submit', (event) => {
    const submitter = event.submitter;

    if (!submitter || !submitter.matches('[data-swt-update-button]')) return;

    event.preventDefault();

    const changedInput = Array.from(form.querySelectorAll('[data-swt-quantity-input]')).find((input) => {
      const nextValue = String(clampToRules(input, input.value));
      return nextValue !== String(input.getAttribute('data-swt-original-value') || '');
    });

    if (!changedInput) return;

    changedInput.value = String(clampToRules(changedInput, changedInput.value));
    goToLineChange(changedInput.closest('[data-swt-cart-line]'), changedInput, 0);
  });
})();
